import {
  useCallback, useState,
} from 'react';
import { useTranslation } from 'react-i18next';
import {
  ItemsContainer, ItemsWrapper, TIMELINE_ITEMS_GAP_PX, TimelineLabel,
} from '../timeline.styled';
import STRING_KEYS from '../../../../../../language/keys';
import EducationContainerItem from './education-container-item/education-container-item.component';

const MAX_ITEMS_IN_CLOSED_STATE = 1;

// Disables to show more X items functionality. To re enable it, delete this variable and comment out the relevant comments
const isExpanded = true;

const EducationContainer = ({ items }: EducationContainerProps): JSX.Element | null => {
  const { t: translate } = useTranslation();
  const [[minimizedHeight, fullHeight], setHeights] = useState<[number, number]>([-1, -1]);
  // const [isExpanded, setIsExpanded] = useState<boolean>(false);
  // const moreItemsToShowAmount = useMemo(() => items.length - MAX_ITEMS_IN_CLOSED_STATE, [items.length]);

  // TODO: put in hook and reuse it in experience container
  const itemsWrapperRef = useCallback((node: HTMLDivElement) => {
    if (!node) {
      return null;
    }

    let childrenHeights = 0;
    if (node && node.children?.length) {
      for (let i = 0; i < MAX_ITEMS_IN_CLOSED_STATE && i < node.children.length; i++) {
        childrenHeights += node.children[i].clientHeight || 0;
      }
      childrenHeights += (MAX_ITEMS_IN_CLOSED_STATE - 1) * TIMELINE_ITEMS_GAP_PX;
    }

    setHeights([childrenHeights, node.clientHeight]);

    return node;
  }, []);

  if (!items?.length) {
    return null;
  }

  return (
    <div>
      <TimelineLabel>
        { translate(STRING_KEYS.MATCH_CARD.EDUCATION_LABEL) }
      </TimelineLabel>
      <ItemsContainer
        minimized={ !isExpanded }
        minimizedHeight={ minimizedHeight }
        fullHeight={ fullHeight }
      >
        <ItemsWrapper ref={ itemsWrapperRef }>
          { items.map((item) => <EducationContainerItem key={ item.educationId } educationItem={ item } />) }
        </ItemsWrapper>
      </ItemsContainer>
    </div>
  );
};

export default EducationContainer;
